import { useDispatch } from "react-redux"

import { bindActionCreators } from "@reduxjs/toolkit"

import { buildingReferenceActions } from "./buildingReferenceSlice"

export function useBuildingReferenceActions() {
  const dispatch = useDispatch()
  return bindActionCreators(buildingReferenceActions, dispatch)
}
